import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { YoutubeAnalyticsPostsSortOrder } from '@anytag/graphql';

export const InfluencerYtSponsoredPostsListSearchSchema = SearchSchema.create({
  sort: { field: YoutubeAnalyticsPostsSortOrder },
  filter: { schema: z.object({ keyword: SearchSchema.types.string() }) }
});

export type InfluencerYtSponsoredPostsListSearchSchemaType = z.infer<typeof InfluencerYtSponsoredPostsListSearchSchema>;
